import { gql } from "@apollo/client"

export const EDIT_USER = gql`
    mutation updateUser($input: UpdateUserInput!) {
        updateUser(input: $input) {
            clientMutationId
        }
    }
`;